<template>
  <div class="registeredList">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-registeredList">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">{{ $t("Registeredlist.dda") }}</span>
              <div class="pull-right">
                <el-button type="primary" @click="daochu">
                  {{ $t("Common.btn_export") }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="registeredList-container">
            <div class="content">
              <div class="content-nav--head text-1">
                <!-- <div class="c-n--head_lf">
                  <s pan class="mr10">已报名名单</span>
                </div>-->
                <div class="c-n--head_lf">
                  <div class="head-right">
                    {{ $t("Registeredlist.ab") }}
                    <el-select
                      filterable
                      v-model="selectForm.chiefPerson"
                      class="mr15"
                      style="width: 150px"
                      clearable
                      :placeholder="$t('Registeredlist.ac')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="head-right" v-if="company_isassist == 1">
                    {{ $t("Registeredlist.ad") }}
                    <el-select
                      filterable
                      v-model="selectForm.chiefPerson_fu"
                      class="mr15"
                      style="width: 150px"
                      clearable
                      :placeholder="$t('Registeredlist.ae')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="head-right">
                    {{ $t("Registeredlist.af") }}
                    <el-select
                      filterable
                      v-model="selectForm.course"
                      class="mr15"
                      style="width: 150px"
                      clearable
                      :placeholder="$t('Registeredlist.ag')"
                      @change="handleSelect()"
                    >
                      <el-option
                        :label="$t('Registeredlist.ah')"
                        value
                      ></el-option>
                      <el-option
                        v-for="(item, index) in SchoolCourseOption"
                        :key="index"
                        :label="`${item.course_cnname}(${item.course_branch})`"
                        :value="item.course_branch"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="head-right mr10">
                    {{ $t("Registeredlist.ai") }}
                    <el-date-picker
                      v-model="selectForm.range_time"
                      type="daterange"
                      style="width: 240px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                  <div class="flex-al mr10">
                    <span class="mr10 fs14 color-666">{{
                      $t("Registeredlist.source_label")
                    }}</span>
                    <div class="select-box flex-al">
                      <el-select
                        filterable
                        style="width: 150px"
                        v-model="selectForm.client_fromtype"
                        @change="handleSelect()"
                        :placeholder="$t('Registeredlist.al')"
                      >
                        <el-option
                          :label="$t('Registeredlist.ah')"
                          value
                        ></el-option>
                        <el-option
                          :label="$t('Registeredlist.sourceList[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('Registeredlist.sourceList[1]')"
                          value="1"
                        ></el-option>
                        <el-option
                          :label="$t('Registeredlist.sourceList[2]')"
                          value="2"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="flex-al mr10">
                    <span class="mr10 fs14 color-666">{{
                      $t("Registeredlist.ak")
                    }}</span>
                    <div class="select-box flex-al">
                      <el-select
                        filterable
                        style="width: 150px"
                        v-model="selectForm.source"
                        @change="handleNameSelect()"
                        :placeholder="$t('Registeredlist.al')"
                      >
                        <el-option
                          :label="$t('Registeredlist.ah')"
                          value
                        ></el-option>
                        <el-option
                          v-for="item in SchoolsourceOption"
                          :key="item.frommedia_id"
                          :label="item.frommedia_name"
                          :value="item.frommedia_name"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="flex-al mr10">
                    <span class="mr10 fs14 color-666">{{
                      $t("Registeredlist.am")
                    }}</span>
                    <div class="select-box">
                      <el-select
                        filterable
                        style="width: 150px"
                        v-model="selectForm.channel"
                        class="select-mini"
                        @change="handleSelect()"
                        :placeholder="$t('Registeredlist.an')"
                      >
                        <el-option
                          :label="$t('Registeredlist.ah')"
                          value
                        ></el-option>
                        <el-option
                          v-for="item in ChannelOption"
                          :key="item.channel_id"
                          :label="item.channel_name"
                          :value="item.channel_id"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>

                  <el-input
                    clearable
                    :placeholder="$t('Registeredlist.ao')"
                    class="input-cont input-keword"
                    style="width: 350px"
                    @change="handleSelectKeyword()"
                    v-model="selectForm.keyword"
                  ></el-input>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Registeredlist.ap") }}</el-button
                  >
                  <!-- <div class="btn-advancedFiter font-gray">
                    <i class="fiter-advance">
                      <img src="../../assets/images/filter.png" alt>
                    </i>
                    高级筛选
                  </div>-->
                  <!-- <el-button type="primary">转回招生线索</el-button> -->
                </div>
              </div>

              <TableList
                :list="tableData"
                :options="optionscaozuo"
                :columns="columns"
                :operates="operates"
                :issetting="true"
                :tableOperate="tableOperate"
                @toggleEditableColumn="toggleEditableColumn"
                @handleColumnChange="handleColumnChange"
              ></TableList>

              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
          <!-- 侧边栏查看-->
          <SliderBox
            :showSliderBox="showSliderBoxSee"
            @hideSliderBox="hideSliderSeeBox"
            :sliderWidth="sliderWidth"
          >
            <userSeeing
              :activeName="activeName"
              :showUserSliderBox="showSliderBoxSee"
              :createJG="createJG"
              :customerId="customerId"
              :ClassMessage="ClassMessage"
              :seeSliderTitle="seeSliderTitle"
              :isTrack="isTrack"
              :isRoot="isRoot"
              :isshowfirst="true"
              :isForm="true"
              :isHome="isHome"
              :isnotBiding="true"
              @hideUserSliderBox="hideSliderSeeBox"
              @studentBinding="studentBinding"
              @handleSliderClick="handleSliderClick"
              @Clickedit="Clickedit"
              @leaning="leaning"
              @onFllowSubmit="onFllowSubmit"
              @ClickFloow="ClickFloow"
              @addConnect="addConnect"
              fromType="registeredList"
              :refreshInfo="refreshInfo"
              @changeRefreshInfoStatus="refreshInfo = false"
              @ClickAudition="ClickAudition"
              @ClickAuditiontime="ClickAuditiontime"
              @updateList="updateList"
            ></userSeeing>
          </SliderBox>
          <!-- 编辑列 -->
          <el-dialog
            :title="$t('Registeredlist.aq')"
            class="setting-column"
            :visible.sync="settingVisible"
            width="450px"
            :before-close="handleClose"
          >
            <el-transfer
              :titles="[$t('Registeredlist.ar'), $t('Registeredlist.as')]"
              v-model="oprateColumn"
              @change="Changeoprate()"
              :data="data"
            ></el-transfer>
            <div class="oprate">
              <el-button
                type="primary"
                size="small"
                @click="handClickOprate()"
                >{{ $t("Registeredlist.at") }}</el-button
              >
            </div>
          </el-dialog>
          <!-- 取消转正提示 -->
          <el-dialog
            :title="$t('Registeredlist.au')"
            :visible.sync="cancelRegister"
            width="30%"
            :before-close="handleClose"
          >
            <div class="del-box">
              <div class="delTips tc">{{ $t("Registeredlist.av") }}</div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="delDonversionAction()">{{
                $t("Registeredlist.at")
              }}</el-button>
              <el-button @click="cancelRegister = false">{{
                $t("Registeredlist.aw")
              }}</el-button>
            </span>
          </el-dialog>

          <!-- 跟班试听 中间-->
          <auditClass
            :leaningVisible="leaningVisible"
            :auditionGenre="auditionGenre"
            :Auditiontime="Auditiontime"
            @handClickcompare="handClickcompare"
            @handClickcancel="handClickcancel"
            @handleClose="handleCloseLean"
          ></auditClass>

          <el-dialog
            title="添加推荐人"
            :visible.sync="addConnectVis"
            class="tan-binding"
            width="500px"
          >
            <div class="positive-div">
              <el-form ref="PositiveFrom" :model="addConnectForm">
                <el-form-item label>
                  <div class="recommend-content">
                    <el-input
                      v-model="addConnectForm.keyword"
                      style="width: 300px"
                      placeholder="推荐人姓名、联系电话、学员编号搜索"
                      @keydown.enter.native.stop.prevent="searchConnect"
                    >
                      <i
                        style="cursor: pointer"
                        @click="searchConnect"
                        slot="suffix"
                        class="el-icon-search"
                      ></i>
                      <!-- 弹出框 -->
                    </el-input>
                    <el-button type="primary" @click="searchConnect"
                      >搜索</el-button
                    >
                    <div class="mt20">
                      <span> <span style="color: red">*</span>推荐人： </span>
                      <template v-if="!selecRecomInfo">暂无</template>
                      <template v-else>
                        {{ selecRecomInfo.student_cnname }}
                        {{ selecRecomInfo.student_enname }}
                        {{ selecRecomInfo.parenter_mobile }}
                        <template>
                          <span class="ml20">就读学校：</span>
                          {{ selecRecomInfo.school_cnname }}
                        </template>
                      </template>
                    </div>

                    <div
                      @click.stop
                      v-if="recommendPopVisable"
                      class="recommend-poplist"
                    >
                      <radioTableCont
                        :tableData="keytableList"
                        @singleBox="singleBox"
                      ></radioTableCont>
                      <div class="pop__arrow"></div>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button
                @click.stop.prevent="addClientSponsorAction"
                type="primary"
                >{{ $t("Customersmanage.av") }}</el-button
              >
              <el-button @click.stop.prevent="addConnectVis = false">{{
                $t("Customersmanage.bj")
              }}</el-button>
            </span>
          </el-dialog>
        </div>
      </el-main>
    </PageNav>

    <!-- 申请变更渠道 -->
    <SliderBox
      :showSliderBox="showApplyChange"
      :sliderWidth="minSliderwidth"
      @hideSliderBox="showApplyChange = false"
    >
      <div class="silder-contain slider-admissionCue slider-top-see">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("Customersmanage.eaa") }}
          </p>
          <el-button
            type="default"
            class="pull-right"
            @click="showApplyChange = false"
          >
            取消
          </el-button>
          <el-button
            @click="handleApply"
            type="primary"
            class="pull-right mr20"
          >
            {{ $t("Customersmanage.eab") }}
          </el-button>
        </div>
        <div class="slider-cont text-1">
          <template v-if="applyChannelRow">
            <div class="apply-channel__desc" v-if="applyChannelRow.status == 1">
              <em class="el-icon-warning mr10"></em>
              {{ $t("Customersmanage.eac") }}
            </div>
            <div class="apply-user-pop">
              <div class="user-info__img">
                <img
                  :src="
                    applyChannelRow.client_img ||
                    (applyChannelRow.client_sex == '男'
                      ? require('@/assets/images/default-img-man.png')
                      : require('@/assets/images/default-img-women.png'))
                  "
                  alt=""
                />
              </div>
              <span class="user-info__name"
                >{{ applyChannelRow.client_cnname }}
                <em class="user-tips" v-if="applyChannelRow.status == 1">
                  {{ $t("Customersmanage.dbf") }}
                </em>
              </span>
            </div>
            <el-form
              :model="applyFormData"
              ref="applyFormRef"
              label-width="120px"
            >
              <el-form-item :label="$t('Customersmanage.ead')">
                <el-input
                  disabled
                  style="width: 340px"
                  v-model="applyChannelRow.channel_medianame"
                ></el-input>
              </el-form-item>
              <el-form-item label="原渠道明细：">
                <el-input
                  disabled
                  style="width: 340px"
                  v-model="applyChannelRow.channel_name"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('Customersmanage.eaf')"
                prop="frommedia_id"
                :rules="[
                  { required: true, message: $t('Customersmanage.eag') },
                ]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  :placeholder="$t('Customersmanage.eag')"
                  v-model="applyFormData.frommedia_id"
                  @change="applyChannelChange"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.sourceList"
                    :key="index"
                    :label="item.frommedia_name"
                    :value="item.frommedia_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('Customersmanage.eah')"
                prop="channel_id"
                :rules="[
                  { required: true, message: $t('Customersmanage.eaj') },
                ]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  :placeholder="$t('Customersmanage.eaj')"
                  v-model="applyFormData.channel_id"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.channelList"
                    :key="index"
                    :label="item.channel_name"
                    :value="item.channel_id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <template
                v-if="
                  applyFormData.channel_id == 436 &&
                  $store.state.COMPANY_ID === '8888'
                "
              >
                <el-form-item label="地推工号：" prop="promotion_id">
                  <el-select
                    filterable
                    v-model="applyFormData.promotion_id"
                    style="width: 340px"
                    placeholder="请输入地推工号"
                    reserve-keyword
                    remote
                    :remote-method="remotePromotion"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in groundPromotionList"
                      :key="item.promotion_id"
                      :label="`${item.promotion_name}（${item.promotion_jobnumber}）`"
                      :value="item.promotion_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template
                v-if="
                  applyFormData.frommedia_id == '387' &&
                  applyFormData.channel_id == '107' &&
                  $store.state.COMPANY_ID === '8888'
                "
              >
                <el-form-item class="recommend-content">
                  <el-input
                    v-model="applyFormData.recommend_keyword"
                    style="width: 283px"
                    @clear="searchRecomend"
                    @input="$forceUpdate()"
                    @keyup.enter.native="searchRecomend"
                    :placeholder="$t('User.placeholder18')"
                  >
                    <i
                      slot="suffix"
                      @click="searchRecomend"
                      class="el-input__icon cur-pointer el-icon-search"
                    ></i>
                  </el-input>
                  <el-button type="primary" size="large" @click="searchRecomend"
                    >搜索</el-button
                  >
                  <!-- 弹出框 -->
                  <div
                    @click.stop
                    v-if="recommendPopVisable"
                    class="recommend-poplist"
                  >
                    <radioTableCont
                      :tableData="keytableList"
                      @singleBox="keySingleBox"
                    ></radioTableCont>
                    <div class="pop__arrow"></div>
                  </div>
                </el-form-item>
                <el-form-item
                  :label="$t('User.label_text22')"
                  prop="client_sponsor"
                  :rules="[{ required: true, message: '请选择推荐人' }]"
                >
                  <div
                    v-if="selecRecomInfo.student_cnname"
                    class="recommend-info"
                  >
                    {{ selecRecomInfo.student_cnname }}
                    {{ selecRecomInfo.student_enname }}
                    {{ selecRecomInfo.parenter_mobile }}
                    <span></span>
                    {{ $t("User.label_text23")
                    }}{{ selecRecomInfo.school_cnname }}
                  </div>
                  <div v-else>{{ $t("User.tips") }}</div>
                </el-form-item>

                <el-form-item
                  :rules="[{ required: true, message: '请选择推荐教师' }]"
                  label="推荐教师"
                  prop="client_teacherid"
                >
                  <el-select
                    filterable
                    v-model="applyFormData.client_teacherid"
                    clearable
                    style="width: 340px"
                    placeholder="请选择推荐教师"
                    @change="filterClientTeacher"
                  >
                    <el-option
                      v-for="item in recommendTeacherList"
                      :key="item.staffer_id"
                      :label="item.marketer_name"
                      :value="item.staffer_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <el-form-item
                :label="$t('Customersmanage.eak')"
                prop="channellog_changetime"
                style="width: 340px"
                :rules="[
                  { required: true, message: $t('Customersmanage.eal') },
                ]"
              >
                <el-date-picker
                  type="date"
                  :placeholder="$t('Customersmanage.eal')"
                  value-format="yyyy-MM-dd"
                  v-model="applyFormData.channellog_changetime"
                  style="width: 340px"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item
                label="上传附件："
                prop="channellog_img"
                style="width: 340px"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :data="Uploadeimg"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <div
                    style="
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                    "
                  >
                    <img
                      v-if="applyFormData.channellog_img"
                      :src="applyFormData.channellog_img"
                    />
                    <template v-else>
                      <i class="el-icon-plus"></i>
                      <div class="el-upload__text">请上传图片</div>
                    </template>
                  </div>
                </el-upload>
              </el-form-item> -->

              <el-form-item
                :label="$t('Customersmanage.eam')"
                prop="channellog_img"
              >
                <el-upload
                  ref="uploadRef"
                  class="avatar-uploader"
                  id="uploadSty"
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :multiple="multiple"
                  :data="Uploadeimg"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture-card"
                  :file-list="fileList"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                >
                  <i
                    style="display: block; padding-top: 50px"
                    class="el-icon-plus"
                  ></i>
                  <div style="margin-top: -50px" class="el-upload__text">
                    {{ $t("Customersmanage.ean") }}
                  </div>

                  <el-dialog
                    id="dialogSty"
                    :visible.sync="dialogVisibles"
                    :modal-append-to-body="false"
                    append-to-body
                  >
                    <img
                      width="100%"
                      :src="applyFormData.channellog_img2"
                      alt=""
                    />
                  </el-dialog>
                </el-upload>
              </el-form-item>

              <el-form-item
                :label="$t('Customersmanage.eao')"
                prop="reason"
                :rules="[
                  { required: true, message: $t('Customersmanage.eap') },
                ]"
              >
                <el-input
                  type="textarea"
                  :rows="6"
                  style="width: 340px"
                  v-model="applyFormData.reason"
                  :placeholder="$t('Customersmanage.eap')"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="紧急程度："
                prop="degree"
                :rules="[{ required: true, message: '请选择紧急程度' }]"
              >
                <el-select
                  filterable
                  clearable
                  style="width: 340px"
                  placeholder="请选择紧急程度"
                  v-model="applyFormData.degree"
                >
                  <el-option
                    v-for="(item, index) in applyFormData.degreeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </template>
        </div>
      </div>
    </SliderBox>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
import SliderBox from "@/components/SliderBox";
import userSeeing from "@/components/User/seeing.vue";
import TableList from "@/components/Table/table.vue";
import radioTableCont from "@/components/tables/radioTableCont";
import auditClass from "@/components/Class/Class.vue";
import storeRegisteredList from "./registeredList.js";

export default {
  name: "Registeredlist-registeredList",
  data() {
    return {
      loading: false,
      groundPromotionList: [],
      multiple: true,
      dialogVisibles: false,
      fileList: [],
      Uploadeimg: {
        company_id: this.$store.state.COMPANY_ID,
        ossfile: "",
      },
      minSliderwidth: "620px",
      applyChannelRow: null,
      showApplyChange: false, // 变更渠道显示
      applyFormData: {
        frommedia_id: "",
        frommedia_name: "",
        channellog_changetime: "",
        // channellog_img: "",
        recommend_keyword: "",
        client_teachername: "",
        client_teacherid: "",
        client_sponsor: "",
        promotion_id: "",
        channellog_img: [],
        channellog_img2: "",
        sourceList: [], // 渠道类型
        channel_id: "",
        channelList: [], // 渠道明细
        reason: "",
        degree: "",
        degreeList: [
          { label: "低", value: "0" },
          { label: "中", value: "1" },
          { label: "高", value: "2" },
        ],
      },

      addConnectVis: false,
      recommendPopVisable: false,
      selecRecomInfo: {},
      recommendTeacherList: [],
      refreshInfo: false,
      addConnectForm: {
        keyword: "",
      },
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          RadioSelect: true,
          errortip: "", //空页面提示内容
          tableHeight: "300px",
        },
      },
      keytableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          RadioSelect: true,
          errortip: "", //空页面提示内容
          tableHeight: "300px",
        },
      },

      openMenu: ["5"],
      showSliderBox: false,
      showSliderBoxSee: false,
      leaningVisible: false,
      createJG: false,
      ReviewVisible: false, //是否审核
      seeSliderTitle: this.$t("Registeredlist.dda"),
      clientLevelNum: "", //存储意向星级数目
      ClassMessage: {}, //选择的试听班级
      inviteInfor: [],
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isHome: true, //是否点击跟进
      isRoot: false,
      current: 0,
      filtersOption: [
        this.$t("Registeredlist.ay"),
        this.$t("Registeredlist.az"),
      ],
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配

      fullscreenLoading: true, //全屏loading
      settingVisible: false,
      cancelRegister: false, //取消转正弹框
      client_id: "", //单个客户id
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      data: [],
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      selectForm: {
        course: "",
        chiefPerson: "",
        chiefPerson_fu: "",
        conversionlog_day: "", //报名日期
        range_time: "", //创建时间
        client_fromtype: "", // 招生来源类型：0外部招生1内部招生2专案招生 （固定参数）
        source: "",
        channel: "",
        keyword: "",
      },
      SchoolCourseOption: [],
      // 招生渠道类型
      SchoolsourceOption: [],
      ChannelOption: [], //渠道明细
      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      activeName: "first",

      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: Number, //表格高度
        errortip: "",
        // specialColumns:true//特殊列
      },
      columns: [],
      allColumns: [],
      operates: {
        width: 150,
        label: this.$t("Registeredlist.ba"),
        align: "center",
        fixed: "right",
        list: [
          // {
          //   id: "1",
          //   label: this.$t("Registeredlist.bb"),
          //   type: "text",
          //   show: true,
          //   plain: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.cancelRegister = true;
          //     this.client_id = row.client_id;
          //   }
          // },
          {
            id: "2",
            label: this.$t("Customersmanage.by"),
            type: "text",
            show: true,
            plain: true,
            Customfloow: true,
            disabled: false,
            method: (index, row) => {
              (() => {})(index, row);
              this.isRoot = true;
              this.iscanEdit = false;
              this.isTrack = true;
              this.isHome = false;
              this.activeName = "fourth";
              this.from_client_id = row.client_id;
              this.customerId = row.client_id; //存储客户ID
              // this.getclientOneData(row.client_id);
              // this.getclientOneTrackData(row.client_id);
              // this.getFriendRelationData(row.client_id);
              // this.getclientOneInviteData(row.client_id); //柜询记录
              // this.getclientOneAuditionData(row.client_id); //试听记录
              // this.getBindingClientData(row.client_id);//绑定学员信息
              this.showSliderBoxSee = true;
            },
          },
          {
            id: "3",
            label: this.$t("Registeredlist.ddb"),
            type: "text",
            show: true,
            plain: true,
            Customfloow: true,
            disabled: false,
            isApplayChange: true,
            method: (index, row) => {
              (() => {})(index, row);
              this.applyChannelRow = row;
              // this.frommediaName = row.channel_medianame
              this.frommediaName = "";
              // this.applyFormData.channel_id = row.channel_id
              this.getSourceApi();
              this.showApplyChange = true;
            },
          },
        ],
      }, // 列操作按钮
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },

      // 试听
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
    };
  },
  components: {
    PageNav,
    SliderBox,
    userSeeing,
    TableList,
    auditClass,
    radioTableCont,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    if (this.postbe_crmlevel == "0") {
      this.operates.list = [];
    }

    let conversionlogStartday = this.$route.query.conversionlog_startday;
    let conversionlogEndday = this.$route.query.conversionlog_endday;
    if (conversionlogStartday && conversionlogEndday) {
      this.selectForm.range_time = [conversionlogStartday, conversionlogEndday];
    }

    this.getsucessclientData(this.pagenum);
    this.getMarketer(); // 获取招生的负责人
    this.getArealyCourseApiData(); // 获取学校的课程
    this.getSourceData();
    this.getChannelData(); //获取招生渠道明细
    this.optionscaozuo.tableHeight = this.$Common.getTableHeight(330); //设置表格高度
    this.getReMarketerApi();
  },
  watch: {
    addConnectVis(n) {
      if (!n) {
        this.addConnectForm.keyword = "";
        this.selecRecomInfo = "";
        this.recommendPopVisable = false;
      }
    },

    showApplyChange(n) {
      if (!n) {
        this.applyFormData.frommedia_id = "";

        this.applyFormData.client_teachername = "";
        this.applyFormData.client_teacherid = "";
        this.applyFormData.client_sponsor = "";
        this.applyFormData.recommend_keyword = "";
        this.selecRecomInfo = {};

        this.$refs["applyFormRef"].resetFields();
      }
    },
  },
  mounted() {},
  methods: {
    filterClientTeacher() {
      let list = this.recommendTeacherList.filter(
        (v) => this.applyFormData.client_teacherid == v.staffer_id
      );
      if (list.length > 0) {
        this.applyFormData.client_teachername = list[0]["staffer_cnname"];
      } else {
        this.applyFormData.client_teachername = "";
      }
    },
    remotePromotion(query) {
      if (query) {
        this.loading = true;
        this.$http
          .getGroundPromotionApi({
            promotion_jobnumber: query,
          })
          .then((res) => {
            const { code, data: _jb } = res.data;

            const data = _jb;
            if (code === 200) {
              this.groundPromotionList = data.list;
            } else {
              this.groundPromotionList = [];
            }
            this.loading = false;
          });
      } else {
        this.groundPromotionList = [];
      }
    },

    getReMarketerApi() {
      storeRegisteredList.getReMarketerApi({}).then((res) => {
        if (res.data.code === 200) {
          this.recommendTeacherList = res.data.data.list;
        } else {
          this.recommendTeacherList = [];
        }
      });
    },
    // 检索推荐人
    searchRecomend() {
      if (this.applyFormData.recommend_keyword == "") {
        this.$message({
          message: this.$t("User.errorMessage1"),
          type: "error",
        });
      } else {
        this.keyGetClientStudentApi(); //招生有效名单->获取可选推荐人-lujing
      }
    },
    keyGetClientStudentApi() {
      storeRegisteredList
        .getClientStudentApi({
          keyword: this.applyFormData.recommend_keyword, //渠道类型名称
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const data = body;
          this.keytableList.columns = data.field;
          if (code === 200) {
            this.keytableList.list = data.list;
          } else {
            this.keytableList.list = [];
          }
          this.keytableList.options.errortip = msg;
          this.recommendPopVisable = true;
          this.$forceUpdate();
        });
    },

    updateList() {
      this.getsucessclientData();
    },
    handleRemove(file, fileList) {
      (() => {})(file, fileList);
    },
    handlePictureCardPreview(file) {
      (() => {})(file);
      // this.dialogImageUrl = file.url;
      this.applyFormData.channellog_img2 = file.response.data.picture_imgurl;
      this.dialogVisibles = true;
    },
    // 申请变更 提交
    handleApply() {
      this.$refs.uploadRef.clearFiles();
      this.$refs["applyFormRef"].validate((v) => {
        if (v) {
          this.applyChannelAction();
        } else {
          return false;
        }
      });
    },
    // 申请变更
    applyChannelAction() {
      storeRegisteredList
        .applyChannelAction({
          client_id: this.applyChannelRow.client_id,
          from_channel_id: this.applyChannelRow.channel_id,
          to_channel_id: this.applyFormData.channel_id,
          channellog_changetime: this.applyFormData.channellog_changetime,
          promotion_id: this.applyFormData.promotion_id,
          client_teachername: this.applyFormData.client_teachername,
          client_teacherid: this.applyFormData.client_teacherid,
          client_sponsor: this.applyFormData.client_sponsor,
          recommend_keyword: this.applyFormData.recommend_keyword,
          // channellog_img: this.applyFormData.channellog_img,
          channellog_img: JSON.stringify(this.applyFormData.channellog_img),
          channellog_note: this.applyFormData.reason,
          channellog_level: this.applyFormData.degree,
          student_branch: this.selecRecomInfo.student_branch || "",
        })
        .then((res) => {
          const { code, msg } = res.data;
          if (code === 200) {
            this.getsucessclientData();
            this.showApplyChange = false;
            this.$message.success(msg);
          } else {
            this.$message.error(msg);
          }
        });
    },
    getSourceApi() {
      this.$http.getSource({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code !== 200 || !data || !data.list) return;
        data.list.forEach((e) => {
          if (e.frommedia_name == this.frommediaName) {
            this.applyFormData.frommedia_id = e.frommedia_id;
          }
        });
        this.applyFormData.sourceList = data.list;
        this.getChannel();
      });
    },
    applyChannelChange() {
      this.applyFormData.sourceList.forEach((e) => {
        if (e.frommedia_id == this.applyFormData.frommedia_id) {
          this.frommediaName = e.frommedia_name;
        }
      });
      this.applyFormData.channel_id = "";
      this.getChannel();
    },
    getChannel() {
      this.$http
        .getChannel({
          channel_medianame: this.frommediaName,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.applyFormData.channelList = data.list;
          } else {
            this.applyFormData.channelList = [];
          }
        });
    },

    addConnect() {
      this.addConnectVis = true;
    },
    searchConnect() {
      (() => {})("searchConnect");
      this.getClientStudentApi();
    },
    // 添加联系人
    addClientSponsorAction() {
      if (this.selecRecomInfo) {
        storeRegisteredList
          .addClientSponsorAction({
            client_id: this.from_client_id,
            student_branch: this.selecRecomInfo.student_branch,
            client_sponsor: this.selecRecomInfo.student_cnname,
          })
          .then((res) => {
            const { code, msg } = res.data;
            if (code === 200) {
              this.refreshInfo = true;
              this.addConnectVis = false;
              this.$message.success(msg);
            } else {
              this.$message.error(msg);
            }
          });
      } else {
        this.$message.error("请选择推荐人");
      }
    },
    keySingleBox(v) {
      this.selecRecomInfo = v;
      this.recommendPopVisable = false;
      this.applyFormData.client_sponsor = v.student_cnname;
    },
    // 单选框
    singleBox(val) {
      this.selecRecomInfo = val;
      // this.form.client_sponsor = val.student_cnname;
      // this.form.client_stubranch = val.student_branch;
      this.recommendPopVisable = false;
      
    },
    //招生有效名单->获取可选推荐人-lujing
    getClientStudentApi() {
      storeRegisteredList
        .getClientStudentApi({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          client_id: this.from_client_id,
          keyword: this.addConnectForm.keyword, //渠道类型名称
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const data = body;
          this.keytableList.columns = data.field;
          (() => {})(this.keytableList.columns);
          if (code === 200) {
            this.keytableList.list = data.list;
          } else {
            this.keytableList.list = [];
          }
          this.keytableList.options.errortip = msg;
          this.recommendPopVisable = true;
        });
    },
    // 已报名名单表格数据
    getsucessclientData() {
      storeRegisteredList
        .getsucessclient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          // 非必须传
          main_marketer_id: this.selectForm.chiefPerson,
          fu_marketer_id: this.selectForm.chiefPerson_fu,
          course_branch: this.selectForm.course,
          client_source: this.selectForm.source,
          channel_id: this.selectForm.channel,
          client_fromtype: this.selectForm.client_fromtype,
          conversionlog_startday: this.selectForm.range_time
            ? this.selectForm.range_time[0]
            : "",
          conversionlog_endday: this.selectForm.range_time
            ? this.selectForm.range_time[1]
            : "",
          keyword: this.selectForm.keyword,
        })
        .then((res) => {
          // 
          this.tableData = res.data.data.list;
          this.dataNumber = parseInt(res.data.data.allnum);
         
          var Columns = res.data.data.field;
          this.allColumns = res.data.data.field;
          this.$Tool.setStorage("allregisterColumns", this.allColumns);
          this.showColumn = JSON.parse(
            localStorage.getItem("showregisterColumns")
          );
          var fieldColumns = res.data.data.field;
          if (JSON.parse(localStorage.getItem("showregisterColumns"))) {
            Columns = this.showColumn;
            fieldColumns = this.showColumn;
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.columns.forEach((v) => {
            if (v.prop == "client_tag") {
              this.$set(v, "istag", true);
              this.$set(v, "width", "220px");
            }
          });
          this.optionscaozuo.loading = false;
          var arr = [];
          var arr2 = [];
          fieldColumns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0",
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
          if (res.data.code !== 200) {
            this.optionscaozuo.errortip = res.data.msg;
          }
          (() => {})(this.columns);
        });
    },
    // 获取学校的课程
    getArealyCourseApiData() {
      // SchoolClassOption
      storeRegisteredList
        .getArealyCourseApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.SchoolCourseOption = res.data.data.list;
          //重置筛选
          // this.SchoolCourseOption.unshift(
          //   {
          //     course_branch: "", course_cnname: "不限"
          //   }
          // );
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeRegisteredList
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          this.chiefPerson.unshift({
            marketer_id: "",
            marketer_name: this.$t("Registeredlist.ah"),
          });
        });
    },
    //获取招生渠道类型
    getSourceData() {
      storeRegisteredList
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.SchoolsourceOption = res.data.data.list;
          // this.SchoolsourceOption.unshift({
          //   frommedia_id: "",
          //   frommedia_name: "不限"
          // });
        });
    },
    //获取招生渠道明细
    getChannelData() {
      storeRegisteredList
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          channel_medianame: this.selectForm.source,
        })
        .then((res) => {
          this.ChannelOption = res.data.data.list;
        });
    },
    // Crm->删除转正记录-取消转正
    delDonversionAction() {
      storeRegisteredList
        .delDonversionAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.client_id,
          postbe_crmlevel: this.postbe_crmlevel,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getsucessclientData(this.pagenum);
            this.cancelRegister = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getsucessclientData(this.pagenum);
    },
    // 选择查询--渠道类型
    handleNameSelect() {
      this.currentPage = 1;
      this.getChannelData(); //获取招生渠道明细
      this.getsucessclientData(this.pagenum);
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getsucessclientData(this.pagenum);
    },
    // 编辑列
    Changeoprate() {
      (() => {})("列变化");
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allregisterColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showregisterColumns", this.showColumns);
      this.settingVisible = false;
      this.getsucessclientData(this.pagenum);
      (() => {})(allnum);
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    onSubmit() {
      (() => {})(this.form);
    },
    changeSize() {
      (() => {})("change");
    },
    handleOneClick(v1) {
      this.visitedJG = true;
      (() => {})(v1);
    },
    handleTwoClick(v1) {
      this.visitingJG = true;
      (() => {})(v1);
    },
    handleClick(v) {
      this.showSliderBox = true;
      (() => {})(v);
      //  this.canvasWidth();
      //  this.comparedDrawLine();
      // this.$message({
      //   message: `123232421432535`,
      //   type: 'success'
      // })
    },
    handleClose(done) {
      this.$refs.uploadRef.clearFiles();
      this.$confirm(this.$t("Registeredlist.be"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.getsucessclientData(this.pagenum);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.getsucessclientData(val);
    },

    handleAvatarSuccess(res, file, fileList) {
      (() => {})(res, file);
      this.imageUrl = URL.createObjectURL(file.raw);
      // if (res.code === 200) {
      //   this.applyFormData.channellog_img = res.data.picture_imgurl;
      // }
      this.applyFormData.channellog_img = fileList.map((item) => {
        return item.response.data.picture_imgurl;
      });
    },
    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === "image/jpeg";
    //   const isLt2M = file.size / 1024 / 1024 < 2;

    //   if (!isJPG) {
    //     this.$message.error(this.$t("Registeredlist.bi"));
    //   }
    //   if (!isLt2M) {
    //     this.$message.error(this.$t("Registeredlist.bj"));
    //   }
    //   return isJPG && isLt2M;
    // },
    beforeAvatarUpload(file) {
      (() => {})(file);
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // const isGIF = file.type === "image/gif";
      const isImg = isJPG || isPNG;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error(" 上传图片只能是 JPG/PNG 格式 !");
      }
      if (!isLt2M) {
        this.$message.error(" 上传图片大小不能超过 2MB!");
      }

      return isImg && isLt2M;
    },

    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean(done) {
      this.$confirm(this.$t("Customersmanage.cb"))
        .then((_) => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      (() => {})(v);
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeRegisteredList
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeRegisteredList
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeRegisteredList
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getsucessclientData(this.pagenum, "");
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = true;
      this.iscanEdit = false;
      this.isTrack = true;
      this.isHome = true;
      // this.activeName = "fourth";

      // this.isRoot = false;
      // this.iscanEdit = true;
      this.activeName = "first";
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      // this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.showSliderBoxSee = true;
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      // v.client_id=this.followFormid;
      (() => {})(v);
      storeRegisteredList.trackClientAction(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getsucessclientData(this.pagenum, "");
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        //  this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let conversionlog_startday = this.selectForm.range_time
        ? this.selectForm.range_time[0]
        : "";
      let conversionlog_endday = this.selectForm.range_time
        ? this.selectForm.range_time[1]
        : "";
      params_str = `&main_marketer_id=${this.selectForm.chiefPerson}&fu_marketer_id=${this.selectForm.chiefPerson_fu}&course_branch=${this.selectForm.course}&client_source=${this.selectForm.source}&channel_id=${this.selectForm.channel}&client_fromtype=${this.selectForm.client_fromtype}&keyword=${this.selectForm.keyword}&conversionlog_startday=${conversionlog_startday}&conversionlog_endday=${conversionlog_endday}`;
      let url = storeRegisteredList.getsucessclient1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  computed: {
    company_isassist() {
      return this.$store.state.companyIsassist;
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("registeredList.less");
.registeredList {
  height: 100vh;
  font-size: 20px;
}
.recommend-content {
  position: relative;
  .recommend-poplist {
    position: absolute;
    left: 0;
    top: 50px;
    background: #fff;
    z-index: 300;
    min-width: 335px;
    max-width: 600px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    // padding: 12px;
    color: #606266;
    font-size: 14px;
    line-height: 23px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .pop__arrow,
    .pop__arrow:after {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
    }
    .pop__arrow {
      top: -6px;
      left: 35%;
      margin-right: 3px;
      border-top-width: 0;
      border-bottom-color: #ebeef5;
    }
    .pop__arrow:after {
      top: 1px;
      margin-left: -6px;
      border-top-width: 0;
      border-bottom-color: #fff;
    }
  }
}
.registeredList {
  height: 100vh;
  font-size: 20px;
  .apply-channel__desc {
    display: flex;
    margin: 0 -20px;
    line-height: 35px;
    align-items: center;
    justify-content: center;
    color: rgba(32, 168, 216, 1);
    background-color: rgba(32, 168, 216, 0.14);
  }
  .apply-channel__notice {
    color: red;
  }
  .apply-user-pop {
    display: flex;
    padding: 20px;
    align-items: center;
    .user-info__img {
      width: 100px;
      padding-right: 13px;
      display: flex;
      justify-content: flex-end;
      img {
        display: block;
        width: 53px;
        height: 53px;
        border-radius: 50%;
      }
    }
    .user-info__name {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      display: flex;
      align-items: center;
      .user-tips {
        margin-left: 20px;
        padding: 0 8px;
        font-size: 14px;
        line-height: 30px;
        font-style: normal;
        color: rgba(32, 168, 216, 1);
        border-radius: 5px;
        background-color: rgba(32, 168, 216, 0.05);
      }
    }
  }
  .choose-user-row {
    display: flex;
    padding: 0 20px;
    .tit {
      width: 100px;
    }

    .user-content {
      flex: 1;
      padding-top: 2px;
      margin-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
    }

    .user-content-item {
      margin: 0 30px 15px 0;
      position: relative;
      .el-icon-circle-close {
        top: -5px;
        right: -15px;
        position: absolute;
        color: red;
        cursor: pointer;
        &:hover {
          color: #20a8d8;
        }
      }
    }
  }

  .slider-channel-record {
    .user-header {
      display: flex;
      padding-top: 20px;
      align-items: flex-start;
      position: relative;
      .user-header__desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        .desc {
          display: flex;
          margin-bottom: 5px;
          align-items: center;
        }
        .desc-sex__img {
          margin: 0 15px 0 5px;
        }
        .tag-normal {
          padding: 0 5px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #20a8d8;
          line-height: 26px;
          border: 1px solid #20a8d8;
          border-radius: 3px;
        }
        .tag-status {
          padding: 0 6px;
          line-height: 26px;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
        }
        .tag-red {
          background: #f35c5c;
        }
        .tag-blue {
          background: #20a8d8;
        }
        .tag-yellow {
          background: #f8cd09;
        }
      }
      .notice-tags {
        right: 20px;
        top: 20px;
        width: 98px;
        height: 98px;
        position: absolute;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          transform: rotate(-15deg);
          position: relative;
        }
        &.notice-success {
          color: #20a8d8;
          border: 1px solid #20a8d8;
        }
        &.notice-fail {
          color: #f35c5c;
          border: 1px solid #f35c5c;
        }
      }
      .user-header__img {
        margin-right: 10px;
      }
      td {
        width: 200px;
        line-height: 30px;
      }
    }

    .channel-apply-info {
      li {
        margin-bottom: 15px;
        font-size: 14px;
      }
      .tit {
        color: #aaa;
      }
      .desc {
        color: #666;
      }
    }
  }

  .channel-view__tabs {
    .el-tabs__nav {
      padding-left: 0;
    }
  }
  .slider-channel-record {
    .el-row .grid-content-img img {
      height: 100%;
    }
    .slider-studentBind .el-row .el-col {
      min-height: 178px;
    }
    .el-row .grid-content > p {
      height: auto;
    }
    .el-row .grid-content .communite-cont {
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      p {
        flex: 1;
      }
      .btns {
        width: 135px;
        margin-left: 10px;
        .el-button {
          width: 60px;
        }
        .btn-disabled {
          background-color: #cccccc;
          border-color: #cccccc;
        }
      }
    }
    .el-row .grid-content .communite-replay {
      display: flex;
      border-top: 1px dashed #ddd;
      .replay-cont {
        flex: 1;
        line-height: 24px;
      }
      .img {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .replay-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .channel-history {
    margin: 0 0 0 10px;
    padding-bottom: 10px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 10px;
      width: 1px;
      height: 100%;
      background-color: rgba(40, 171, 217, 1);
      border-radius: 50%;
    }
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      margin-bottom: 20px;
    }
    .channel-history__title {
      margin: 0 0 10px 0;
      padding-left: 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a4a4a4;
      line-height: 20px;
      letter-spacing: 1px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: -5px;
        top: 5px;
        width: 6px;
        height: 6px;
        padding: 2px;
        border: 1px solid rgba(0, 173, 223, 1);
        background-color: rgba(0, 173, 223, 1);
        background-clip: content-box;
        border-radius: 50%;
      }
    }
    .channel-history-box {
      width: 96%;
      margin: 0 auto;
      padding: 20px 30px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);
      .channel-row {
        display: flex;
        align-items: flex-start;
        .channel-detail {
          display: flex;
          flex: 5;
          padding: 16px 0;
          align-items: center;
          justify-content: space-around;
          background-color: rgba(32, 168, 216, 0.05);
          .channel-detail__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #3a3a3a;
            line-height: 19px;
            letter-spacing: 1px;
            p {
              &:last-child {
                margin-top: 20px;
              }
            }
          }
          .channel-detail__tips {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 47px;
              height: 25px;
            }
            p {
              font-size: 12px;
              font-family: MicrosoftYaHei;
              color: #aaaaaa;
              line-height: 16px;
              letter-spacing: 1px;
            }
          }
        }
        .channel-status {
          flex: 2;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .dot {
            width: 6px;
            height: 6px;
            margin-right: 5px;
            border-radius: 50%;
          }
          &.status-success {
            color: rgba(32, 168, 216, 1);
            .dot {
              background-color: rgba(32, 168, 216, 1);
            }
          }
          &.status-fail {
            color: rgba(243, 92, 92, 1);
            .dot {
              background-color: rgba(243, 92, 92, 1);
            }
          }
          &.status-wait {
            color: rgba(6, 217, 3, 1);
            .dot {
              background-color: rgba(6, 217, 3, 1);
            }
          }
          &.status-warn {
            color: rgba(255, 203, 0, 1);
            .dot {
              background-color: rgba(255, 203, 0, 1);
            }
          }
        }
      }
    }
    .channel-history__teacher {
      margin-top: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #55606e;
      line-height: 19px;
      letter-spacing: 1px;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
  .tab-num-tips {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -8px;
    font-size: 13px;
    color: #fff;
    line-height: 100%;
    font-style: normal;
    text-align: center;
    line-height: 16px;
    vertical-align: top;
    background-color: red;
    border-radius: 50%;
  }
}

#uploadSty {
  .el-dialog__wrapper {
    overflow: hidden !important;
  }
  .el-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
    height: 50px;
  }
  .el-dialog__body {
    border: none !important;
  }
}
// .v-modal {
//   z-index: -99 !important;
// }
#dialogSty {
  .el-dialog__header {
    padding: 0 !important;
    height: 50px;
  }
  .el-dialog__body {
    border: none !important;
  }
}
</style>
